import { validateSubscriptions } from "../../form/validationForm";
import { useState } from "react";
import { useForm } from "../../hooks/utils/useForm";
import { ValidationError } from "../../form/validationForm";
import { apiRepository } from "../../../api/apiRepository";
import { openModal } from "../../utils/modalsUtils";
import { handleError } from "../../utils/errorUtils";

export const useCreateSubscription = () => {
    const initialFormData = { email: "", fullName: "" };
    const { formData, handleChange, resetForm: originalResetForm } = useForm(initialFormData);
    const [loading, setLoading] = useState(false);
    const [serverError, setServerError] = useState<ValidationError[]>([]);

    const resetForm = () => {
        originalResetForm();
        setServerError([]);
    };

    const handleCreateSubscription = async (event: React.FormEvent, subscriptionData?: { email: string, fullName: string }) => {
        event.preventDefault();
        setServerError([]);

        const dataToUse = subscriptionData || formData;
        if (!dataToUse) return;

        const validationErrors = validateSubscriptions(dataToUse);
        if (validationErrors.length > 0) {
            setServerError(validationErrors);
            return;
        }

        try {
            setLoading(true);
            const response = await apiRepository.createSubscriptions(dataToUse);
            const { status } = response;

            if (status) {
                openModal("subscription-success-modal");
                setServerError(prevErrors => [...prevErrors, { field: 'success', message: 'Suscripción hecha con éxito' }]);
            }
        } catch (error: any) {
            handleError(error, setServerError);
        } finally {
            setLoading(false);
        }
    };

    return { formData, handleChange, resetForm, handleCreateSubscription, loading, serverError };
};